import React from 'react';

const AppleSvg = (props) => (
    <svg
        className="apple_svg__eds-icon--health_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="apple_svg__eds-icon--health_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M13.7 4.4c.4-.5 1-.7 1.7-.7 0 .6-.3 1.2-.7 1.7-.4.5-1 .7-1.7.7 0-.7.3-1.3.7-1.7zm7.1 8l-2.1 6.4c-.4 1.3-1.7 2.2-3 2.2-.4 0-.8-.1-1.2-.2-.6-.3-1.3-.4-1.9-.4-.7 0-1.3.1-1.9.4-.5.1-1 .2-1.4.2-1.4 0-2.6-.9-3-2.2l-2.1-6.4c-.3-1-.2-2.1.4-2.9.6-.9 1.6-1.4 2.6-1.4.2 0 .4 0 .6.1l3.8.7c.1 0 .3 0 .4.1v2h1V8.9c.1 0 .3 0 .4-.1l3.9-.7c.2 0 .1-.1.6-.1 1 0 1.9.5 2.5 1.4.6.9.8 2 .4 3zm-2.9-5.3h-.1c-.2 0-.5 0-.8.1l-3.8.7H13v-.8c.9 0 1.7-.3 2.4-1 .9-.9 1.2-2.2.9-3.3-.3-.1-.6-.1-.8-.1-.9 0-1.7.3-2.4 1V2h-1v5.9h-.2l-4-.8c-.3 0-.5-.1-.8-.1-2.8 0-4.9 2.8-3.9 5.6L5.3 19c.7 1.9 2.3 3 4 3 .5 0 1.1-.1 1.6-.3.5-.2 1-.3 1.6-.3.5 0 1.1.1 1.6.3.5.2 1 .3 1.6.3 1.7 0 3.4-1.1 4-2.9l2.2-6.4c.8-2.8-1.5-5.6-4-5.6z"
        />
        <g
            className="apple_svg__eds-icon--health_dashes"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
        >
            <path d="M14 13h1v2h-1zM10 13h1v2h-1z" />
        </g>
    </svg>
);

AppleSvg.displayName = 'AppleSvg';
export default AppleSvg;
